'use strict';

export const ar_DZ = {
    name: 'ar_DZ',
    closeText: 'إغلاق',
    prevText: '&#x3C;السابق',
    nextText: 'التالي&#x3E;',
    currentText: 'اليوم',
    monthNames: ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
    monthNamesShort: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    dayNames: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    dayNamesShort: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    dayNamesMin: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    weekHeader: 'أسبوع',
    dateFormat: 'dd/mm/yy',
    firstDay: 6,
    isRTL: !0,
    showMonthAfterYear: !1,
    yearSuffix: ''
};
